export const BRIDGE_COOKIE_SESSION_ID_KEY = '_bina_bridge_session_id';
export const BRIDGE_STORAGE_KEY = '_bina_bridge_storage';
